import { useState } from "react";
import { CopyIcon, SaveIcon, TrashIcon } from "../../../../../../assets";
import {
  formatDate,
  getText,
  sanitizeHtml,
  truncateHtml,
} from "../../../../../utils/_generic";
import { PDLTypography } from "../../../dna";
import { ActionButton } from "../../../global";

const ItemGenerico = ({
  item,
  index,
  pushDown = false,
  cardProfileStyle = false,
  onRemove,
}) => {
  const [expanded, setExpanded] = useState(false);
  const itemId = item.id || `generico-${index}`;

  const fullHtmlContent = sanitizeHtml(
    item.texto ||
      item.resumo ||
      item.summary ||
      item.content ||
      `Conteúdo não disponível para o item ${itemId}`
  );

  const textOnly = getText(fullHtmlContent);
  const shouldShowToggle = textOnly.length > 300;
  const displayHtmlContent = expanded ? textOnly : truncateHtml(textOnly, 300);

  return (
    <div
      key={itemId}
      className={`pdl_components_lista_resultados_item mt-3 ${
        pushDown ? "push-down" : ""
      } ${cardProfileStyle ? "card-style" : ""}`}
    >
      <PDLTypography size="md" weight="semibold" variant="brand" upper>
        {item.titulo}
      </PDLTypography>
      <div className="result-meta mb-2">
        <span className="result-categories text-uppercase fw-bold text-info">
          {item.tipo} • {item.autor || "Autor"} • {formatDate(item.data)} •{" "}
          {item.fonte || "Fonte"}
        </span>
        <div className="btn-action-container">
          <ActionButton icon={<SaveIcon />} label="Salvar" />
          <ActionButton icon={<CopyIcon />} label="Copiar" />
        </div>
      </div>

      <div className="text-container">
        {item.titulo && <h5 className="mb-2">{item.titulo}</h5>}
        <div className="content">
          <span
            dangerouslySetInnerHTML={{
              __html:
                displayHtmlContent +
                (!expanded && shouldShowToggle ? "..." : ""),
            }}
          />
          {shouldShowToggle && (
            <span
              className="text-primary ms-2 toggle-text"
              style={{ cursor: "pointer" }}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Ver menos" : "Ver mais"}
            </span>
          )}
        </div>
      </div>
      {pushDown && (
        <div className="btn-action-container-footer">
          <div className="btn-action-group-left">
            <ActionButton icon={<CopyIcon />} label="Copiar" />
          </div>
          {onRemove && (
            <div className="btn-action-group-right">
              <button
                type="button"
                className="btn-remove-saved"
                onClick={() => onRemove(item)}
              >
                <TrashIcon color="#8c0000" />
                <span>Remover de salvos</span>
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemGenerico;
